// TODO: Add sorting feature & fix results counter
/* eslint-disable no-shadow */
import React, {createElement,} from 'react';
import ReactDOM from 'react-dom/client';
import App from "./RecipesFilter/App";

// Find the container element: section#recipe-advanced-filter
const domContainer = document.getElementById('recipe-advanced-filter');
const root = ReactDOM.createRoot(domContainer);

// Transfer attributes to variables.
const {
    fastFilterLinks,
    restUrl,
    seriesId,
    difficultyValues,
    mainIngredientValues,
    cookingTimeValues,
    courseValues,
    dietValues,
    styleValues,
    fuelTypeValues,
    featuredValues,
    enableProteinFilter,
} = domContainer.dataset;


// Remove data attributes
domContainer.removeAttribute('data-fast-filter-links');
domContainer.removeAttribute('data-rest-url');
domContainer.removeAttribute('data-difficulty-values');
domContainer.removeAttribute('data-main-ingredient-values');
domContainer.removeAttribute('data-cooking-time-values');
domContainer.removeAttribute('data-course-values');
domContainer.removeAttribute('data-diet-values');
domContainer.removeAttribute('data-style-values');
domContainer.removeAttribute('data-fuel-type-values');
domContainer.removeAttribute('data-featured-values');
domContainer.removeAttribute('data-enable-protein-filter');


const RecipeAdvancedFilter = ({
    restUrl,
    seriesId = false,
    filterLinks = [],
    difficultyValues = [],
    mainIngredientValues = [],
    cookingTimeValues = [],
    courseValues = [],
    dietValues = [],
    styleValues = [],
    fuelTypeValues = [],
    featuredValues = [],
    enableProteinFilter = true,
}) => (
        <App
            filterLinks={filterLinks}
            restUrl = {restUrl}
            seriesId = {seriesId}
            difficultyValues = {difficultyValues}
            mainIngredientValues = {mainIngredientValues}
            cookingTimeValues = {cookingTimeValues}
            courseValues = {courseValues}
            dietValues = {dietValues}
            styleValues = {styleValues}
            fuelTypeValues = {fuelTypeValues}
            featuredValues = {featuredValues}
            enableProteinFilter = {enableProteinFilter} />
    );

root.render(
    createElement(RecipeAdvancedFilter, {
        restUrl,
        seriesId,
        difficultyValues: JSON.parse(difficultyValues),
        mainIngredientValues: JSON.parse(mainIngredientValues),
        cookingTimeValues: JSON.parse(cookingTimeValues),
        courseValues: JSON.parse(courseValues),
        dietValues: JSON.parse(dietValues),
        styleValues: JSON.parse(styleValues),
        fuelTypeValues: JSON.parse(fuelTypeValues),
        featuredValues: JSON.parse(featuredValues),
        enableProteinFilter: enableProteinFilter === '1',
        filterLinks: JSON.parse(fastFilterLinks),
    })
);
